import { render, staticRenderFns } from "./JumpJuliang.vue?vue&type=template&id=12a6d315&scoped=true"
import script from "./JumpJuliang.vue?vue&type=script&lang=js"
export * from "./JumpJuliang.vue?vue&type=script&lang=js"
import style0 from "./JumpJuliang.vue?vue&type=style&index=0&id=12a6d315&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a6d315",
  null
  
)

export default component.exports